const msgError = `Insira um valor válido para items. \n\n
  Exemplo: \n
    - items: '[{"name": "","description": "", "value": 0, "quantity": 0,"sku": ""}]'
    - items: "[{"name": "","description": "", "value": 0, "quantity": 0,"sku": ""}]"`;

export default function handleItems(items) {

  try {
    return JSON.parse(items);
  } catch (error) {

  }

  return items;
};



// WEBPACK FOOTER //
// ./src/handle-items.js